// src/massiveRecruitment/MassiveRecruitmentLayout.js
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { Add as AddIcon, List as ListIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import MassiveRecruitmentList from './MassiveRecruitmentList';
import MassiveRecruitmentForm from './MassiveRecruitmentForm';
import MassiveRecruitmentView from './MassiveRecruitmentView';

const MassiveRecruitmentLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const [currentView, setCurrentView] = useState('list'); // 'list' | 'create' | 'edit' | 'view'
  const [selectedProcess, setSelectedProcess] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 0) {
      setCurrentView('list');
      setSelectedProcess(null);
    } else if (newValue === 1) {
      setCurrentView('create');
      setSelectedProcess(null);
    }
  };

  const handleGoToList = () => {
    setCurrentView('list');
    setSelectedProcess(null);
    setTabValue(0);
  };

  const handleGoToCreate = () => {
    setCurrentView('create');
    setSelectedProcess(null);
    setTabValue(1);
  };

  const handleGoToEdit = (process) => {
    setSelectedProcess(process);
    setCurrentView('edit');
    setTabValue(1);
  };

  const handleGoToView = (process) => {
    setSelectedProcess(process);
    setCurrentView('view');
  };

  const isFullscreenView = currentView === 'view' || currentView === 'edit';

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header y tabs — ocultos en view/edit (pantalla completa) */}
      {!isFullscreenView && (
        <>
          <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
            <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
              {t('massiveRecruitment.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('massiveRecruitment.subTitle')}
            </Typography>
          </Box>

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="massive recruitment tabs">
              <Tab
                icon={<ListIcon />}
                iconPosition="start"
                label={t('massiveRecruitment.tabs.list')}
                id="massive-tab-0"
                aria-controls="massive-tabpanel-0"
              />
              <Tab
                icon={<AddIcon />}
                iconPosition="start"
                label={t('massiveRecruitment.tabs.new')}
                id="massive-tab-1"
                aria-controls="massive-tabpanel-1"
              />
            </Tabs>
          </Box>
        </>
      )}

      {/* Contenido */}
      <Box>
        {currentView === 'list' && (
          <MassiveRecruitmentList
            onNew={handleGoToCreate}
            onEdit={handleGoToEdit}
            onView={handleGoToView}
          />
        )}
        {currentView === 'create' && (
          <MassiveRecruitmentForm
            mode="create"
            onSuccess={handleGoToList}
            onCancel={handleGoToList}
          />
        )}
        {currentView === 'edit' && selectedProcess && (
          <MassiveRecruitmentForm
            mode="edit"
            processId={selectedProcess.uid}
            onSuccess={handleGoToList}
            onCancel={handleGoToList}
          />
        )}
        {currentView === 'view' && selectedProcess && (
          <MassiveRecruitmentView
            processId={selectedProcess.uid}
            onBack={handleGoToList}
            onEdit={handleGoToEdit}
          />
        )}
      </Box>
    </Box>
  );
};

export default MassiveRecruitmentLayout;